import { ErrorMessage, useField } from "formik"
import { Input, Label } from "reactstrap";
import '../../global/GlobalCSS.css'

interface Props {
    label: string;
    name: string;
    on: string;
    off: string;
    [x: string]: any
}

export const CustomSwitch = (props: Props) => {
    const [field] = useField(props)
    return (
        <>
            <div className="d-flex flex-wrap gap-2 mb-3">
                <Label className={props.class}>{props.label}</Label>
                <div className="square-switch sqswitch">
                    <Input type="checkbox" {...field} {...props} switch="none" name={props.name} defaultChecked={props.defaultChecked} checked={props?.checked} />
                    <Label htmlFor={props.name} data-on-label={props.on}
                        data-off-label={props.off}></Label>
                </div>
            </div>
            <ErrorMessage name={props.name} component="span" className="error"></ErrorMessage>
        </>
    )
}